/*global Dingdocs*/

import React, { useContext, useEffect, useRef, useState, useCallback } from 'react';
import { initView } from 'dingtalk-docs-cool-app';
import { Typography, Button, Card, Table, Descriptions, Divider, Popconfirm} from 'dingtalk-design-desktop';
import { ColumnsType } from 'dingtalk-design-desktop/es/table';
import { getLocale, type Locales } from './locales';
import { config } from './config';
import './style.css';

import { keHuXinXi, jiuYeXinXi, shuJuBiao_name, oaInfo } from './locales';
import Editable from './createEditable';
import { Console } from 'console';

interface Sheet {
  id: string;
  name: string;
  desc: string;
  fieldsCount: number;
}

interface Field {
  id: string;
  name: string;
  type: string;
  isPrimary: boolean;
}

interface Record {
  id: string;
  fields: {[key: string]: any};
}

interface DocumentInfo {
  uuid: string;
  sheetsCount: number;
  currentSheet: string;
}

function App() {
  const [locale, setLocale] = useState<Locales>(getLocale('zh-CN'));
  const [loading, setLoading] = useState<boolean>(false);
  const [documentInfo, setDocumentInfo] = useState<DocumentInfo | null>(null);
  const [sheets, setSheets] = useState<Sheet[]>([]);
  const [activeSheet, setActiveSheet] = useState<Sheet | null>(null);
  const [fields, setFields] = useState<Field[]>([]);
  const [records, setRecords] = useState<Record[]>([]);
  
  const [oaInfo, setOaInfo] = useState<oaInfo | null>(null);
  
  //table表格
  const handleSave_table1 = async (row:keHuXinXi, dataIndex:any) => {
    const newData = [...keHuXinXis];
    const index = newData.findIndex(item => row.key === item.key);
    Object.entries(row).forEach(async ([Key,value])=>{
      switch (Key) {
        case "beiZhu":
          if(Key != dataIndex) break;
          Dingdocs.script.run('updateRecord', row.key, { "备注": value }, keHuBiao_id);
          break;
        case "duiJieXiaoShouRenYuan":
          if(Key != dataIndex) break;
          Dingdocs.script.run('updateRecord', row.key, { "对接销售人员": value }, keHuBiao_id);
          break;
        case "keHuDiZhi":
          if(Key != dataIndex) break;
          Dingdocs.script.run('updateRecord', row.key, { "客户地址": value }, keHuBiao_id);
          break;
        case "kehuming":
          if(Key != dataIndex) break;
          Dingdocs.script.run('updateRecord', row.key, { "客户名": value }, keHuBiao_id);
          break;
        case "lianXiFangShi":
          if(Key != dataIndex) break;
          Dingdocs.script.run('updateRecord', row.key, { "联系方式": value }, keHuBiao_id);
          break;
        case "suoShuQuYu":
          if(Key != dataIndex) break;
          Dingdocs.script.run('updateRecord', row.key, { "所属区域": value }, keHuBiao_id);
          break;
        default:
          break;
      }
    })
    const item = newData[index];
    newData.splice(index, 1, {
      ...item,
      ...row,
    }); 
    //setkeHuXinXis(newData);
  };
  const handleSave_table2 = async (row: jiuYeXinXi, dataIndex:any) => {
    const newData = [...jiuYeXinXis];
    const index = newData.findIndex(item => row.key === item.key);
    Object.entries(row).forEach(async ([Key, value]) => {
      switch (Key) {
        case "beiZhu":
          if(Key != dataIndex) break;
          Dingdocs.script.run('updateRecord', row.key, { "备注": value }, chanPinBiao_id);
          break;
        case "pinZhong":
          if(Key != dataIndex) break;
          Dingdocs.script.run('updateRecord', row.key, { "品种": value }, chanPinBiao_id);
          break;
        case "guiGe":
          if(Key != dataIndex) break;
          Dingdocs.script.run('updateRecord', row.key, { "规格": value }, chanPinBiao_id);
          break;
        case "danJia":
          if(Key != dataIndex) break;
          Dingdocs.script.run('updateRecord', row.key, { "单价": value }, chanPinBiao_id);
          break;
        default:
          break;
      }
    })
    const item = newData[index];
    newData.splice(index, 1, {
      ...item,
      ...row,
    });
    //setjiuYeXinXis(newData);
  };
  const handleDelete_table1 = async (key:string, sheetId: any) => {
    try {
      const newData = keHuXinXis.filter(item => item.key !== key);
      Dingdocs.script.run('deleteRecord', key, sheetId);
      //setkeHuXinXis(newData);
      console.log(`✅ ${locale.deleteRecordSuccess}`);
    } catch (error: any) {
      alert(`${locale.operationFailed}: ${error.message}`);
    }
  };
  const handleDelete_table2 = async (key: React.Key, sheetId: any) => {
    try {
      const newData = jiuYeXinXis.filter(item => item.key !== key);
      Dingdocs.script.run('deleteRecord', key, sheetId);
      //setjiuYeXinXis(newData);
      console.log(`✅ ${locale.deleteRecordSuccess}`);
    } catch (error: any) {
      alert(`${locale.operationFailed}: ${error.message}`);
    }
  };

  const components = {
    body: {
      row: Editable.row,
      cell: Editable.cell,
    },
  };
  type EditableTableProps = Parameters<typeof Table>[0];
  type ColumnTypes = Exclude<EditableTableProps['columns'], undefined>;

  const [chuKuShuJuBiao_id,setchuKuShuJuBiao_id] = useState();
  
  //客户信息
  const [keHuBiao_id,setkeHuBiao_id] = useState();//组件用
  let keHuBiao_id_1:any;//函数用
  const [count_keHuXinXi, setCount_keHuXinXi] = useState(1);//用于定义key
  const [keHuXinXis, setkeHuXinXis] = useState<keHuXinXi[]>([]);
  const defaultColumns_table1: (ColumnTypes[number] & { editable?: boolean; dataIndex: string; filtertable?: boolean })[] = [
    //序号
    {
      width: '5%',
      title: '序列号',
      dataIndex: 'index',
    },
    //对接销售人员
    {
      width: '15%',
      title: '对接销售人员',
      dataIndex: 'duiJieXiaoShouRenYuan',
      editable: true,
      filtertable:true,
    },
    //客户名
    {
      width: '15%',
      title: '客户名',
      dataIndex: 'kehuming',
      editable: true,
      filtertable:true,
    },
    //联系方式
    {
      width: '15%',
      title: '联系方式',
      dataIndex: 'lianXiFangShi',
      editable: true,
    },
    //客户地址
    {
      width: '30%',
      title: '客户地址',
      dataIndex: 'keHuDiZhi',
      editable: true,
    },
    //备注
    {
      width: '30%',
      title: '备注',
      dataIndex: 'beiZhu',
      editable: true,
    },
    {
      dataIndex: 'Action',
      title: 'Action',
      fixed: 'right',
      width: 100,
      render: (_, record:any) =>
        keHuXinXis.length >= 1 ? (
          <Popconfirm title="Sure to delete?" onConfirm={async () => handleDelete_table1(record.key, keHuBiao_id)}>
            <a>Delete</a>
          </Popconfirm>
        ) : null,
    },
    
  ];
  const columns_table1 = defaultColumns_table1.map(col => {
    //筛选
    let shuaiXuan = {
      filters: keHuXinXis.map((item: keHuXinXi) => ({ text: item[col.dataIndex as keyof keHuXinXi], value: item[col.dataIndex as keyof keHuXinXi] })),
      filterMode: 'tree',
      filterSearch: true,
      onFilter: (value: boolean | React.Key, record: keHuXinXi) => {
        // 需要先将 value 转换为 string
        return record[col.dataIndex].includes(String(value));
      }
    }

    //可编辑
    let keBianJi = {
      onCell: (record: keHuXinXi) => ({
        record,
        editable: col.editable,
        dataIndex: col.dataIndex,
        title: col.title,
        handleSave: handleSave_table1,
        style:{padding:'0px 5px'}
      }),
    }
    //不编辑，不筛选
    if (!col.editable && !col.filtertable) {
      return col;
    }
    //又编辑又筛选
    if (col.editable && col.filtertable) {
      return {
        ...col,
        ...keBianJi,
        ...shuaiXuan
      }
    }
    //只编辑
    if (col.editable) {
      return {
        ...col,
        ...keBianJi
      }
    }
    //只筛选
    if (col.filtertable) {
      return {
        ...col,
        ...shuaiXuan
      };
    }
  });

  //产品信息
  const [chanPinBiao_id,setchanPinBiao_id] = useState();
  let chanPinBiao_id_1:any;//函数用
  const [count_jiuYeXinXi, setCount_jiuYeXinXi] = useState(1);//用于定义key
  const [jiuYeXinXis, setjiuYeXinXis] = useState<jiuYeXinXi[]>([]);
  const defaultColumns_table2: (ColumnTypes[number] & { editable?: boolean; dataIndex: string; filtertable?: boolean })[] = [
    //序号
    {
      width: '5%',
      title: '序列号',
      dataIndex: 'index',
    },
    //品种
    {
      width: '15%',
      title: '品种',
      dataIndex: 'pinZhong',
      editable: true,
      filtertable: true,
    },
    //规格
    {
      width: '5%',
      title: '规格',
      dataIndex: 'guiGe',
      editable: true,
    },
    //单价
    {
      width: '5%',
      title: '单价',
      dataIndex: 'danJia',
      editable: true,
    },
    //备注
    {
      width: '70%',
      title: '备注',
      dataIndex: 'beiZhu',
      editable: true,
    },
    {
      dataIndex: 'Action',
      title: 'Action',
      fixed: 'right',
      width: 100,
      render: (_, record: any) =>
        jiuYeXinXis.length >= 1 ? (
          <Popconfirm title="Sure to delete?" onConfirm={() => handleDelete_table2(record.key, chanPinBiao_id)}>
            <a>Delete</a>
          </Popconfirm>
        ) : null,
    },

  ];
  const columns_table2 = defaultColumns_table2.map(col => {
    //筛选
    let shuaiXuan = {
      filters: jiuYeXinXis.map((item: jiuYeXinXi) => ({ text: item[col.dataIndex as keyof jiuYeXinXi], value: item[col.dataIndex as keyof jiuYeXinXi] })),
      filterMode: 'tree',
      filterSearch: true,
      onFilter: (value: boolean | React.Key, record: jiuYeXinXi) => {
        // 需要先将 value 转换为 string
        return record[col.dataIndex].includes(String(value));
      }
    }

    //可编辑
    let keBianJi = {
      onCell: (record: jiuYeXinXi) => ({
        record,
        editable: col.editable,
        dataIndex: col.dataIndex,
        title: col.title,
        handleSave: handleSave_table2,
        style: { padding: '0px 5px' }
      }),
    }
    //不编辑，不筛选
    if (!col.editable && !col.filtertable) {
      return col;
    }
    //又编辑又筛选
    if (col.editable && col.filtertable) {
      return {
        ...col,
        ...keBianJi,
        ...shuaiXuan
      }
    }
    //只编辑
    if (col.editable) {
      return {
        ...col,
        ...keBianJi
      }
    }
    //只筛选
    if (col.filtertable) {
      return {
        ...col,
        ...shuaiXuan
      };
    }
  });
  
  // 存储事件监听器的取消函数
  const [eventUnsubscribers, setEventUnsubscribers] = useState<Array<() => void>>([]);

  // 获取主键字段名称，如果没有主键则返回第一个字段名称
  const getPrimaryFieldName = (): string => {
    if (fields.length === 0) return 'ID';
    
    // 查找主键字段
    const primaryField = fields.find(field => field.isPrimary);
    if (primaryField) {
      return primaryField.name;
    }
    
    // 如果没有主键，返回第一个字段
    return fields[0].name;
  };

  // 获取记录的主要显示值
  const getRecordDisplayValue = (record: Record, maxLength: number = 50): string => {
    const primaryFieldName = getPrimaryFieldName();
    const value = record.fields[primaryFieldName];
    
    if (value === null || value === undefined || value === '') {
      return locale.untitled;
    }
    
    let displayValue: string;
    
    // 如果是对象类型的值，尝试提取文本
    if (typeof value === 'object' && value !== null) {
      displayValue = value.text || value.name || JSON.stringify(value);
    } else {
      displayValue = String(value);
    }
    
    // 限制最大长度
    if (displayValue.length > maxLength) {
      return displayValue.substring(0, maxLength) + '...';
    }
    
    return displayValue;
  };

  useEffect(() => {
    const initialize = async () => {
      setLoading(true);
      //设置表格ID
      let sheetList = await Dingdocs.script.run('getAllSheets');
      sheetList.forEach((item: any) => {
        switch (item.name) {
          case shuJuBiao_name.keHuXinXi_name:
            setkeHuBiao_id(item.id);
            keHuBiao_id_1 = item.id;
            break;

          case shuJuBiao_name.chanPinXinXi_name:
            setchanPinBiao_id(item.id);
            chanPinBiao_id_1 = item.id;
            break;

          case shuJuBiao_name.chuJiuShuJuXinXi_name:
            setchuKuShuJuBiao_id(item.id);
            break;
        }
      }
      );
      //审批信息初始化
      try {
        // /oa/getBiaoDanXinXi不加${config.houDuan_url} ngnix后端需要设置
        const res = await fetch(
          `/oa/getBiaoDanXinXi`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json'
          }
        }
        )

        if (!res.ok) {
          throw new Error(`HTTP ${res.status}`)
        }

        const data = await res.json();
        setOaInfo(data);
      } catch (err) {
        console.error('请求失败：', err)
      }
      
      // if (!response.ok) {
      //   throw new Error(`请求失败: ${response.status} ${response.statusText}`);
      // }

      try {
        await Promise.all([
          loadDocumentInfo(),
          loadSheets(),
          loadActiveSheet(),
          loadAllRecords(),
        ]);
      } catch (error: any) {
        console.error(`${locale.operationFailed}: ${error.message}`);
      } finally {
        setLoading(false);
      }
    };

    // 初始化鉴权
    const initConfigPermission = async () => {
      try {
        // 获取当前页面的URL
        const currentUrl = window.location.href;
        console.log('Current URL for config permission:', currentUrl);
        // 从后端服务器请求钉钉配置权限
        const response = await fetch(`/api/configPermission?url=${encodeURIComponent(currentUrl)}`);
        if (!response.ok) {
          throw new Error(`请求失败: ${response.status} ${response.statusText}`);
        }
        
        const configData = await response.json();
        console.log('Received config permission data:', configData);

        // 调用钉钉配置方法
        await Dingdocs.base.host.configPermission(
          configData.agentId,
          configData.corpId,
          configData.timeStamp,
          configData.nonceStr,
          configData.signature,
          configData.jsApiList || ["DingdocsScript.base.readWriteAll"],
        );

        console.log('Config permission set successfully');
      } catch (error) {
        console.error('Config permission error:', error);
        // 保留之前的错误信息，但更友好地处理
        console.warn('Config permission failed - this may affect some functionality');
      }
    };
    
    let unsubscribers: Array<() => void> = [];
    let lastSheetId: string | null = null; // 记录上次的sheetId，避免重复触发
    let debounceTimer: NodeJS.Timeout | null = null; // 防抖定时器

    const setupEvents = () => {
      try {
        // 监听选择变化（包括activeSheet变化）
        const offSelectionChanged = Dingdocs.base.event.onSelectionChanged((selection) => {
          // 只有当sheetId真正变化时才更新状态
          if (selection.sheetId && selection.sheetId !== lastSheetId) {
            lastSheetId = selection.sheetId;
            console.log('Active sheet changed to:', selection.sheetId);

            // 使用防抖来避免频繁调用
            if (debounceTimer) {
              clearTimeout(debounceTimer);
            }
            debounceTimer = setTimeout(() => {
              loadActiveSheet();
              loadDocumentInfo(); // 更新文档信息，包括当前表名
            }, 300); // 300ms防抖延迟
          }
        });
        unsubscribers.push(offSelectionChanged);

        // 监听数据表添加事件
        const offSheetInserted = Dingdocs.base.event.onSheetInserted((event) => {
          console.log('Sheet inserted:', event);
          loadSheets();
          loadDocumentInfo();
        });
        unsubscribers.push(offSheetInserted);

        // 监听数据表删除事件
        const offSheetDeleted = Dingdocs.base.event.onSheetDeleted((event) => {
          console.log('Sheet deleted:', event);
          loadSheets();
          loadDocumentInfo();
          // 如果删除的是当前激活的表，重新加载当前表
          loadActiveSheet();
        });
        unsubscribers.push(offSheetDeleted);

        // 监听字段添加事件
        const offFieldInserted = Dingdocs.base.event.onFieldInserted((event) => {
          console.log('Field inserted:', event);
          // 如果是当前表的字段变化，重新加载字段列表
          if (!activeSheet || event.sheetId === activeSheet.id) {
            loadFields();
          }
          loadSheets(); // 更新字段数量
        });
        unsubscribers.push(offFieldInserted);

        // 监听字段修改事件
        const offFieldModified = Dingdocs.base.event.onFieldModified((event) => {
          console.log('Field modified:', event);
          if (!activeSheet || event.sheetId === activeSheet.id) {
            loadFields();
          }
        });
        unsubscribers.push(offFieldModified);

        // 监听字段删除事件
        const offFieldDeleted = Dingdocs.base.event.onFieldDeleted((event) => {
          console.log('Field deleted:', event);
          if (!activeSheet || event.sheetId === activeSheet.id) {
            loadFields();
          }
          loadSheets(); // 更新字段数量
        });
        unsubscribers.push(offFieldDeleted);

        // 监听记录添加事件
        const offRecordInserted = Dingdocs.base.event.onRecordInserted((event) => {
          console.log('Record inserted:', event);
          loadAllRecords();
          if (!activeSheet || event.sheetId === activeSheet.id) {
            loadRecords();
          }
        });
        unsubscribers.push(offRecordInserted);

        // 监听记录修改事件
        const offRecordModified = Dingdocs.base.event.onRecordModified((event) => {
          console.log('Record modified:', event);
          loadAllRecords()
          if (!activeSheet || event.sheetId === activeSheet.id) {
            loadRecords();
          }
        });
        unsubscribers.push(offRecordModified);

        // 监听记录删除事件
        const offRecordDeleted = Dingdocs.base.event.onRecordDeleted((event) => {
          console.log('Record deleted:', event);
          if (!activeSheet || event.sheetId === activeSheet.id) {
            loadRecords();
            loadAllRecords();
          }
        });
        unsubscribers.push(offRecordDeleted);

        // 保存所有取消监听的函数
        setEventUnsubscribers(unsubscribers);
        
        console.log('Event listeners setup completed');
      } catch (error: any) {
        console.error('Failed to setup event listeners:', error);
      }
    };

    initView({
      onReady: async () => {
        // 获取当前语言设置
        try {
          const currentLocale = await Dingdocs.base.host.getLocale();
          setLocale(getLocale(currentLocale));
        } catch (e) {
          console.warn('Failed to get locale, using default zh-CN');
        }
        // 初始化插件鉴权(公开发布企业内插件/三方企业插件场景下需要解除下方注释进行鉴权)
        await initConfigPermission();

        // 初始化数据
        await initialize();

        // 设置事件监听
        setupEvents();
      },
    });

    // 清理函数
    return () => {
      if (debounceTimer) {
        clearTimeout(debounceTimer);
      }
      unsubscribers.forEach(unsubscribe => {
        try {
          unsubscribe();
        } catch (error) {
          console.warn('Failed to unsubscribe event listener:', error);
        }
      });
    };
  }, []); // 这里故意只在组件挂载时运行一次

  // 清理事件监听器
  useEffect(() => {
    return () => {
      eventUnsubscribers.forEach(unsubscribe => {
        try {
          unsubscribe();
        } catch (error) {
          console.warn('Failed to unsubscribe event listener:', error);
        }
      });
    };
  }, [eventUnsubscribers]);

  // 加载文档信息
  const loadDocumentInfo = useCallback(async () => {
    try {
      const info = await Dingdocs.script.run('getDocumentInfo');
      setDocumentInfo(info);
    } catch (error: any) {
      console.error('Load document info failed:', error);
    }
  }, []);

  // 加载数据表列表
  const loadSheets = useCallback(async () => {
    try {
      const sheetList = await Dingdocs.script.run('getAllSheets');
      setSheets(sheetList);
    } catch (error: any) {
      console.error('Load sheets failed:', error);
    }
  }, []);

  // 加载字段列表
  const loadFields = useCallback(async (sheetId?: string) => {
    try {
      const fieldList = await Dingdocs.script.run('getSheetFields', sheetId);
      setFields(fieldList);
    } catch (error: any) {
      console.error('Load fields failed:', error);
    }
  }, []);

  // 加载当前激活的数据表
  const loadActiveSheet = useCallback(async () => {
    try {
      const sheet = await Dingdocs.script.run('getActiveSheet');
      setActiveSheet(sheet);
      if (sheet) {
        await loadFields(sheet.id);
      }
    } catch (error: any) {
      console.error('Load active sheet failed:', error);
    }
  }, [loadFields]);

  // 加载记录列表
  const loadRecords = useCallback(async (sheetId?: string) => {
    try {
      const recordData = await Dingdocs.script.run('getRecords', sheetId);
      console.log('Loaded records:', recordData);
      setRecords(recordData.records);
    } catch (error: any) {
      console.error('Load records failed:', error);
    }
  }, []);

  // 创建数据表
  const handleCreateSheet = async () => {
    const name = prompt(locale.enterSheetName);
    if (!name || !name.trim()) {
      return;
    }

    try {
      await Dingdocs.script.run('createSheet', name.trim());
      console.log(`✅ ${locale.createSheetSuccess}`);
      await loadSheets();
    } catch (error: any) {
      alert(`${locale.operationFailed}: ${error.message}`);
    }
  };

  // 删除数据表
  const handleDeleteSheet = async (sheetId: string, sheetName: string) => {
    if (!window.confirm(`${locale.confirmDelete}: ${sheetName}?`)) {
      return;
    }

    try {
      await Dingdocs.script.run('deleteSheet', sheetId);
      console.log(`✅ ${locale.deleteSheetSuccess}`);
      await loadSheets();
      if (activeSheet?.id === sheetId) {
        await loadActiveSheet();
      }
    } catch (error: any) {
      alert(`${locale.operationFailed}: ${error.message}`);
    }
  };

  // 添加字段
  const handleAddField = async () => {
    const name = prompt(locale.enterFieldName);
    if (!name || !name.trim()) {
      return;
    }

    setLoading(true);
    try {
      await Dingdocs.script.run('addField', name.trim(), 'text');
      console.log(`✅ ${locale.addFieldSuccess}`);
      await loadFields();
    } catch (error: any) {
      alert(`${locale.operationFailed}: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  // 删除字段
  const handleDeleteField = async (fieldId: string, fieldName: string, isPrimary: boolean) => {
    if (isPrimary) {
      alert(locale.cannotDeletePrimaryKeyField);
      return;
    }

    if (!window.confirm(`${locale.confirmDeleteField} "${fieldName}" ${locale.confirmDelete}？${locale.dataWillBeLost}。`)) {
      return;
    }

    try {
      await Dingdocs.script.run('deleteField', fieldId);
      console.log(`✅ ${locale.deleteFieldSuccess}`);
      await loadFields();
    } catch (error: any) {
      alert(`${locale.deleteFieldFailed}: ${error.message}`);
    }
  };

  // 添加记录
  const handleAddRecord = async () => {
    const title = prompt(locale.enterRecordTitle);
    if (!title || !title.trim()) {
      return;
    }

    try {
      const primaryFieldName = getPrimaryFieldName();
      const recordFields: {[key: string]: any} = {
        [primaryFieldName]: title.trim()
      };
      
      await Dingdocs.script.run('addRecord', recordFields);
      console.log(`✅ ${locale.addRecordSuccess}`);
      await loadRecords();
    } catch (error: any) {
      alert(`${locale.operationFailed}: ${error.message}`);
    }
  };

  // 删除记录
  const handleDeleteRecord = async (recordId: string) => {
    if (!window.confirm(locale.confirmDelete)) {
      return;
    }
    try {
      await Dingdocs.script.run('deleteRecord', recordId);
      console.log(`✅ ${locale.deleteRecordSuccess}`);
      await loadRecords();
    } catch (error: any) {
      alert(`${locale.operationFailed}: ${error.message}`);
    }
  };

  // 加载全部数据列表
  const loadAllRecords = useCallback(async () => {
    try {
      //客户信息加载
      let Records_keHu = await Dingdocs.script.run('loadAllRecords',keHuBiao_id_1);
      let arr_1 = [];
      setCount_keHuXinXi(count_keHuXinXi + 2);
      for (let i = 0; i < Records_keHu.length; i++) {
        const new_KeHuXinXi: keHuXinXi = {
          key: `${Records_keHu[i].id}`,
          index: Number(`${i+1}`),
          duiJieXiaoShouRenYuan: Records_keHu[i].fields?.对接销售人员 ? `${Records_keHu[i].fields?.对接销售人员}`:'-',
          kehuming: Records_keHu[i].fields?.客户名 ? `${Records_keHu[i].fields?.客户名}`:'-',
          keHuDiZhi: Records_keHu[i].fields?.客户地址 ? `${Records_keHu[i].fields?.客户地址}`:'-',
          suoShuQuYu: Records_keHu[i].fields?.所属区域 ? `${Records_keHu[i].fields?.所属区域}`:'-',
          lianXiFangShi: Records_keHu[i].fields?.联系方式 ? `${Records_keHu[i].fields?.联系方式}`:'-',
          beiZhu: Records_keHu[i].fields?.备注 ? `${Records_keHu[i].fields?.备注}`:'-',
        }
        arr_1.push(new_KeHuXinXi);
      }
      setkeHuXinXis(arr_1);
      setCount_keHuXinXi(Records_keHu.length + 1);
      
      //产品信息加载
      let Records_chanPin = await Dingdocs.script.run('loadAllRecords',chanPinBiao_id_1);
      let arr_2 = [];
      for (let i = 0; i < Records_chanPin.length; i++) {
        const new_chanPinXinXi: jiuYeXinXi = {
          key: `${Records_chanPin[i].id}`,
          index: Number(`${i + 1}`),
          pinZhong: Records_chanPin[i].fields?.品种? `${Records_chanPin[i].fields?.品种}` : '-',
          guiGe: Records_chanPin[i].fields?.规格 ? `${Records_chanPin[i].fields?.规格}` : '-',
          danJia: Records_chanPin[i].fields?.单价 ? `${Records_chanPin[i].fields?.单价}` : '-',
          beiZhu: Records_chanPin[i].fields?.备注 ? `${Records_chanPin[i].fields?.备注}` : '-',
        }
        arr_2.push(new_chanPinXinXi);
      }
      setCount_jiuYeXinXi(Records_chanPin.length + 1);
      setjiuYeXinXis(arr_2);
    } catch (error: any) {
      console.error('Load sheets failed:', error);
    }
  }, []);

  if (loading) {
    return (
      <div className='page'>
        <div className='loading'>
          <Typography.Text>{locale.loading}</Typography.Text>
        </div>
      </div>
    );
  }

  return (
    <div className='page'>
      <div className='content'>
        <Card size={'small'} title={"啤酒厂-B端客户审批管理"}>
          <Descriptions title="审批模板信息" layout="vertical">
            <Descriptions.Item label="模板名称">{oaInfo?.oAname}</Descriptions.Item>
            <Descriptions.Item label="审批ID">{oaInfo?.formCode}</Descriptions.Item>
            <Descriptions.Item label="更新时间">{oaInfo?.gmtModified}</Descriptions.Item>
          </Descriptions>
          <Divider style={{ height: '0px' }} />
          <div id="table-demo-edit-cell">
            <Button onClick={async () => {
              let record_id = (await Dingdocs.script.run('addRecord',null,keHuBiao_id)).id;
              const new_KeHuXinXi: keHuXinXi = {
                key: record_id,
                index:Number(`${count_keHuXinXi}`),
                duiJieXiaoShouRenYuan: '-',
                kehuming: '-',
                keHuDiZhi: '-',
                suoShuQuYu:'-',
                lianXiFangShi: '-',
                beiZhu:'-',
              }
              //setkeHuXinXis([...keHuXinXis, new_KeHuXinXi])
              setCount_keHuXinXi(count_keHuXinXi + 1);
            }}
              type="primary" style={{ marginBottom: 16 }}>
              Add a row
            </Button>
            <Table
              components={components}
              rowClassName={() => 'editable-row'}
              bordered
              columns={columns_table1 as ColumnTypes}
              dataSource={keHuXinXis}
              title={() => '客户资料'}
              scroll={{ x: 1500 }}
            />
            <Divider style={{ height: '0px' }} />
            <Button onClick={async () => {
              let record_id = (await Dingdocs.script.run('addRecord',null,chanPinBiao_id)).id;
              const new_jiuYeXinXi: jiuYeXinXi = {
                key: record_id,
                index:Number(`${count_jiuYeXinXi}`),
                pinZhong: '-',
                guiGe: '-',
                danJia: '-',
                beiZhu: '-',
              }
              //setjiuYeXinXis([...jiuYeXinXis, new_jiuYeXinXi]);
              setCount_jiuYeXinXi(count_jiuYeXinXi + 1);
            }}
              type="primary" style={{ marginBottom: 16 }}>
              Add a row
            </Button>
            <Table
              components={components}
              rowClassName={() => 'editable-row'}
              bordered
              columns={columns_table2 as ColumnTypes}
              dataSource={jiuYeXinXis}
              title={() => '产品资料'}
              scroll={{ x: 1500 }}
            />
          </div>
          <Divider style={{ height: '0px' }} />
          <div style={{
            display: 'flex',
            justifyContent: 'center'
          }}>
            <Button onClick={async () => {
              // /oa/uploadAiBiaoGeXiXin不加${config.houDuan_url} ngnix后端需要设置 
              //上传产品、客户数据到后端
              try {
                const res = await fetch(
                  `/oa/uploadAiBiaoGeXiXin`, {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                      keHuXinXin : keHuXinXis,
                      jiuYeXinXi : jiuYeXinXis
                    })
                }
                )
                //品种字段更新
                //产品信息加载
                let Records_chanPin = await Dingdocs.script.run('loadAllRecords', chanPinBiao_id);
                let arr = [];
                for (let i = 0; i < Records_chanPin.length; i++) {
                  arr.push({
                    id: `${Records_chanPin[i].fields?.品种}-${Records_chanPin[i].fields?.规格}-${Records_chanPin[i].fields?.单价}`,
                    name: `${Records_chanPin[i].fields?.品种}-${Records_chanPin[i].fields?.规格}-${Records_chanPin[i].fields?.单价}`
                  });
                }
                console.log(`567890${chuKuShuJuBiao_id}`)
                await Dingdocs.script.run('setPropertyAsync', arr, chuKuShuJuBiao_id);
                if (!res.ok) {
                  throw new Error(`HTTP ${res.status}`)
                } else {
                  const data = await res.json();
                  alert(data.body);
                }
              } catch (err) {
                console.error('请求失败：', err)
              }
            }}
              style={{ width: '400px', justifyContent: 'right' }}
              type="primary"
              size="small"
            >更新审批</Button>
          </div>
        </Card>
      </div>
    </div>
  )
}

export default App;
